import { AppState } from "../../store";
export const getDashboardData = (state: AppState) => state.reducer.Dashboard.data;